import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.7 4.6c-.2-.2-.5-.2-.7 0l-6 6-6-6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l6 6c.4.4 1 .4 1.4 0l6-6c.2-.2.2-.5 0-.7" />
  </svg>
);
const SvgCaretDown = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="caret-down" {...props} />;
export default SvgCaretDown;
